import ExtraLotteries from './ExtraLotteries';

export default ExtraLotteries;
